import React, { useMemo } from 'react';

import { useOperatorAuth } from '@contexts/operator/OperatorAuthContext';
import ErrorBoundary from '@shared/ErrorBoundary';
import { Spin } from 'antd';
import { RouterProvider } from 'react-router-dom';

import { createOperatorRouter } from '@/routes/operatorRouter';


const OperatorApp = () => {
  const { loading: authLoading } = useOperatorAuth();

  // 只在完全準備好後才創建 router
  // 這確保 loader 執行時，所有 Context 都已就緒
  const isReady = !authLoading;

  const router = useMemo(() => {
    if (!isReady) return null;
    return createOperatorRouter();
  }, [isReady]);

  // 等待 Context 初始化完成
  if (!router) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <ErrorBoundary showDetails={import.meta.env.DEV} homeUrl="/operator">
      <RouterProvider router={router} />
    </ErrorBoundary>
  );
};

export default OperatorApp;
